<template>
  <div class="flex_vh100 home">
    <div>
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    </div>
    <div class="detail-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item, index) in list" :key="index" class="detail-item">
            <van-cell-group>
              <van-cell title="日期" :value="item.date.substring(0, 10)" />
              <van-cell
                v-if="type == 1"
                title="登录人次"
                :value="item.count || 0"
              />
              <van-cell
                v-if="type == 1"
                title="用户最高在线"
                :value="item.count3 || 0"
              />
              <van-cell
                v-if="type == 1"
                title="机器人最高在线"
                :value="item.count2 || 0"
              />
              <van-cell
                v-if="type == 2"
                title="注册人数"
                :value="item.count || 0"
              />
              <van-cell
                v-if="type == 3"
                title="充值金额"
                :value="(item.count || 0) / 100"
              />
              <van-cell
                v-if="type == 4"
                title="房卡消耗"
                :value="item.count || 0"
              />
            </van-cell-group>
          </div>
          <van-empty
            v-if="finished && list.length === 0"
            description="暂无数据"
          />
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { GetPlatFormStatisticsDetails } from "../api/financeapi.js";

const TYPE_MAP = {
  1: "在线人数",
  2: "注册人数",
  3: "充值金额",
  4: "房卡消耗",
};

export default {
  name: "OnlineStatisicsDetail",
  data() {
    return {
      type: 1,
      title: "在线人数",
      list: [],
      loading: false,
      refreshing: false,
      finished: false,
      startDate: null,
      endDate: null,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // 获取日期字符串 YYYY-MM-DD 00:00:00
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day} 00:00:00`;
    },

    // 初始化日期范围：endDate=今天, startDate=30天前
    initDateRange() {
      const today = new Date();
      const start = new Date();
      start.setDate(today.getDate() - 30);
      this.endDate = this.formatDate(today);
      this.startDate = this.formatDate(start);
    },

    // 根据最后一条数据的日期，向前取30天
    recalcDateRange() {
      const lastDate = new Date(this.startDate.substring(0, 10));
      const start = new Date(lastDate);
      start.setDate(start.getDate() - 30);
      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(lastDate);
    },

    // 查询数据
    async fetchData() {
      try {
        const res = await GetPlatFormStatisticsDetails({
          startDate: this.startDate,
          endDate: this.endDate,
          type: this.type,
        });
        return Array.isArray(res) ? res.reverse() : [];
      } catch {
        Toast.fail("数据加载失败");
        return [];
      }
    },

    // 下拉刷新：重置到初始30天
    async onRefresh() {
      this.initDateRange();
      this.finished = false;
      const data = await this.fetchData();
      this.list = data;
      this.finished = data.length === 0;
      this.refreshing = false;
      this.loading = false;
      this.recalcDateRange();
    },

    // 上拉加载更多：以最后一条数据为基准向前取30天
    async onLoad() {
      console.log("加载数据")
      if (this.refreshing) return;
      const data = await this.fetchData();

      if (data.length === 0) {
        this.finished = true;
      } else {
        this.list = [...this.list, ...data];
        this.recalcDateRange();
      }

      this.loading = false;
    },
  },
  created() {
    this.type = Number(this.$route.query.type) || 1;
    this.title = TYPE_MAP[this.type] || "详情";
    this.initDateRange();
  },
};
</script>

<style scoped>
.detail-content {
  flex: 1;
  overflow-y: auto;
  background-color: #f5f6f8;
}

.detail-item {
  background-color: #fff;
  margin: 10px 12px;
  border-radius: 8px;
  overflow: hidden;
}

.detail-item :deep(.van-cell-group) {
  background-color: transparent;
}

.detail-item :deep(.van-cell-group::after) {
  display: none;
}

.detail-item :deep(.van-cell) {
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
}

.detail-item :deep(.van-cell::after) {
  display: none;
}

.detail-item :deep(.van-cell__title) {
  color: #323233;
  font-size: 13px;
}

.detail-item :deep(.van-cell__value) {
  color: #969799;
  font-size: 13px;
}
</style>
